; (function ($, window, document, undefined) {
    'use strict';
    // nom de librairie à modifier
    Foundation.libs.product = {
        name: 'product',

        version: '1.0.0',

        settings: {
            callback: function () { }
        },

        module360: null,
        hasPaymentModalBeenInitialized: false,
        hasReviewsModalBeenInitialized: false,
        hasFidelityModalBeenInitialized: false,
        hasShippingModalBeenInitialized: false,
        hasReturnModalBeenInitialized: false,
        hasRentModalBeenInitialized: false,
        hasSealingModalBeenInitialized: false,
        hasCresusModalBeenInitialized: false,
        hasClickAndCollectModalBeenInitialized: false,
        hasCustomizationModalBeenInitialized: false,
        hasStoreReservationModalBeenInitialized: false,
        rentContext: null,

        //interval: {},
        init: function (scope, method, options) {
            // initialisation à conserver
            Foundation.inherit(this, '');
            var self = this;
            this.productReveal;

            // à conserver
            this.bindings(method, options);
        },

        show: function (el) {
            if (el.classList.contains("hidden")) el.classList.remove("hidden");
        },

        hide: function (el) {
            if (!el.classList.contains("hidden")) el.classList.add("hidden");
        },

        initGlobal: function () {
            this.initImages();
            this.initInformations();
        },

        initImages: function () {
            this.initProductImagesSliders();
            this.initModule360();
        },

        initInformations: function () {
            Foundation.libs.matyModals.init();

            this.hasDescriptionModalBeenInitialized = false;
            this.hasPaymentModalBeenInitialized = false;
            this.hasReviewsModalBeenInitialized = false;
            this.hasFidelityModalBeenInitialized = false;
            this.hasShippingModalBeenInitialized = false;
            this.hasReturnModalBeenInitialized = false;
            this.hasRentModalBeenInitialized = false;
            this.hasSealingModalBeenInitialized = false;
            this.hasCresusModalBeenInitialized = false;
            this.hasClickAndCollectModalBeenInitialized = false;
            this.hasCustomizationModalBeenInitialized = false;
            this.hasStoreReservationModalBeenInitialized = false;

            this.initMobileBottom();
            this.initSizePickers();
            this.initModals();
            this.initClickAndCollect();
            this.initCustomizationModal();
            this.initEditCustomizationButtons();
            this.initDeleteCustomizationButtons();
            this.initAlmaWidget();
            this.initRent();
            this.initGiftCard();
            this.initAddToCartButton();
            this.initReviewsWidget();
        },

        initReviewsWidget: function () {
            if (SkeepersProductWidget) {
                SkeepersProductWidget.generate();
            }
        },

        initAddToCartButton: function () {
            const addToCartButtons = document.querySelectorAll(".add-to-cart:not(-initialized)");
            if (addToCartButtons.length == 0) return;

            Array.from(addToCartButtons).forEach(button => {
                button.addEventListener("click", async () => {
                    await this.addProductToCart();
                    Foundation.libs.mastertag.trackAddToCart({ trigger: 'ajout_panier', category: 'ajout panier' });
                })

                button.classList.add("-initialized");
            })
        },

        initModals: function () {
            this.initCharacteristicsModalActivators();

            const descriptionModal = document.getElementById("description-modal")?.modal;
            if (descriptionModal) this.initModal("hasDescriptionModalBeenInitialized", descriptionModal, () => {
                Foundation.libs.mastertag.trackModals("description");
            });

            const paymentModal = document.getElementById("payment-modal")?.modal;
            if (paymentModal) this.initModal("hasPaymentModalBeenInitialized", paymentModal, () => {
                this.fetchModalContent("payment-modal-content", "/Product/GetPaymentModalContent", paymentModal);
                Foundation.libs.mastertag.trackModals("paiement");
            });

            const reviewsModal = document.getElementById("reviews-modal")?.modal;
            if (reviewsModal) this.initModal("hasReviewsModalBeenInitialized", reviewsModal, () => {
                this.fetchReviewsModal();
                Foundation.libs.mastertag.trackModals("avis");
            });

            const fidelityModal = document.getElementById("fidelity-modal")?.modal;
            const productPrice = document.getElementById("product-price")?.value;
            if (fidelityModal && productPrice) this.initModal("hasFidelityModalBeenInitialized", fidelityModal, () => {
                this.fetchModalContent("fidelity-modal-content", "/Product/GetFidelityModalContent?sellingPrice=" + productPrice, fidelityModal);
                Foundation.libs.mastertag.trackModals("fidelite");
            });

            const shippingModal = document.getElementById("shipping-modal")?.modal;
            if (shippingModal) this.initModal("hasShippingModalBeenInitialized", shippingModal, () => {
                this.fetchModalContent("shipping-modal-content", "/Product/GetModalContent?modalType=shipping", shippingModal);
                Foundation.libs.mastertag.trackModals("livraison");
            });

            const returnModal = document.getElementById("return-modal")?.modal;
            if (returnModal) this.initModal("hasReturnModalBeenInitialized", returnModal, () => {
                this.fetchModalContent("return-modal-content", "/Product/GetModalContent?modalType=return", returnModal);
                Foundation.libs.mastertag.trackModals("retour");
            });

            const rentModal = document.getElementById("rent-modal")?.modal;
            if (rentModal) this.initModal("hasRentModalBeenInitialized", rentModal, () => {
                this.fetchModalContent("rent-modal-content", "/Product/GetModalContent?modalType=rent", rentModal);
                Foundation.libs.mastertag.trackModals("location");
            });

            const sealingModal = document.getElementById("sealing-modal")?.modal;
            if (sealingModal) this.initModal("hasSealingModalBeenInitialized", sealingModal, () => {
                this.fetchModalContent("sealing-modal-content", "/Product/GetModalContent?modalType=sealing", sealingModal);
                Foundation.libs.mastertag.trackModals("etancheite");
            });

            const cresusModal = document.getElementById("cresus-modal")?.modal;
            if (cresusModal) this.initModal("hasCresusModalBeenInitialized", cresusModal, () => {
                this.fetchModalContent("cresus-modal-content", "/Product/GetModalContent?modalType=cresus", cresusModal);
                Foundation.libs.mastertag.trackModals("cresus");
            });

            const storeReservationModal = document.getElementById("store-reservation-modal")?.modal;
            if (storeReservationModal) this.initModal("hasStoreReservationModalBeenInitialized", storeReservationModal, async () => {
                await this.fetchModalContent("store-reservation-modal-wrapper", "/Product/GetModalContent?modalType=storeReservation", storeReservationModal);
                this.initEReservationWebModal(storeReservationModal);
            })
        },

        initModal: function (initializationPropertyName, modal, onOpenCallback = null) {
            if (this[initializationPropertyName] == true) return;

            if (!modal) return;

            if (onOpenCallback == null) return;

            modal.onOpen(() => onOpenCallback());

            modal.onClose(() => { Foundation.libs.product[initializationPropertyName] = false; });

            this[initializationPropertyName] = true;
        },

        fetchModalContent: async function (contentWrapperId, apiUrl, modal) {
            const wrapper = document.getElementById(contentWrapperId);

            try {
                Foundation.libs.common.showPreloader();

                const response = await fetch(apiUrl);
                const data = await response.json();

                if (data.isValid && data.html) {
                    wrapper.innerHTML = data.html;
                    modal.reinitContent();
                } else {
                    throw Error();
                }
            } catch (e) {
                console.error(e);
                this.setErrorInModal(wrapper);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        fetchReviewsModal: async function () {
            const modal = document.getElementById("reviews-modal").modal;
            const wrapper = document.getElementById("reviews-modal-content");

            try {
                Foundation.libs.common.showPreloader();

                const reference = document.getElementById("product-reference")?.value;
                const title = document.getElementById("product-title")?.value;
                const sellingPrice = parseFloat(document.getElementById("product-price")?.value) || 0;

                const params = new URLSearchParams({ reference, title, sellingPrice });

                const response = await fetch("/Product/GetReviewsModalContent?" + params);
                const data = await response.json();

                if (data.isValid && data.html) {
                    wrapper.innerHTML = data.html;

                    SkeepersProductWidget?.generate();

                    modal.reinitContent();
                } else {
                    throw Error();
                }
            } catch (e) {
                console.error(e);
                this.setErrorInModal(wrapper);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        initEReservationWebModal: function (modal) {
            console.log("initmodal");
            const button = document.getElementById("saveEReservationWebButton");
            const wrapper = modal.element.querySelector(".content__section");


            const reference = document.getElementById("product-reference")?.value ?? "";
            const variant = document.getElementById("product-selected-variant")?.value ?? "";

            const params = new URLSearchParams({ reference, variant })

            const _this = this;

            button.addEventListener("click", async function () {
                try {
                    Foundation.libs.common.showPreloader();

                    const response = await fetch("/ProductAction/SaveEReservationWithDeposit?" + params, {
                        method: "POST"
                    });

                    const data = await response.json();

                    if (data.isValid) {
                        if (data.html) {
                            const informationsWrapper = document.getElementById("product-informations");

                            informationsWrapper.replaceWith(
                                document.createRange().createContextualFragment(data.html)
                            );

                            _this.initInformations();
                        }

                        if (data.productCount) {
                            const cartPictogram = document.getElementById("cart-pictogram");
                            let productCountEl = document.querySelector("#cart-pictogram .product-nb");

                            if (!productCountEl) {
                                const el = document.createElement("span");
                                el.classList.add("product-nb");

                                if (cartPictogram) {
                                    cartPictogram.appendChild(el);
                                }

                                productCountEl = document.querySelector("#cart-pictogram .product-nb");
                            }

                            if (productCountEl) {
                                productCountEl.innerText = data.productCount;
                            }
                        }

                        await _this.getAddToCartModal();
                    } else {
                        wrapper.innerHTML = `<p class="-error">${data.error}</p>`;
                    }
                }
                catch (e) {
                    console.error(e);
                    _this.setErrorInModal(wrapper);
                }
                finally {
                    Foundation.libs.common.hidePreloader();
                }
            })
        },

        initCharacteristicsModalActivators: function () {
            const activators = [];

            const redPriceChip = document.querySelector(".price-wrapper .red-price .chip");
            if (redPriceChip) activators.push(redPriceChip);

            const characteristicTopActivator = document.querySelector(".product-informations__top .description-activator");
            if (characteristicTopActivator) activators.push(characteristicTopActivator);

            if (activators.length == 0) return;

            const characteristicsModal = document.getElementById("description-modal");
            if (!characteristicsModal) return;

            activators.forEach(activator => {
                activator.addEventListener("click", () => characteristicsModal.modal.open());
            });
        },

        initGiftCard: function () {
            const isGiftCard = document.getElementById("is-gift-card")?.value ?? false;

            if (!isGiftCard) return;

            this.initGiftCardCustomizationModal();
        },

        initGiftCardCustomizationModal: async function () {
            const modal = document.getElementById("gift-card-customization-modal")?.modal ?? null;
            const reference = document.getElementById("product-reference")?.value ?? null;
            const isVirtualGiftCard = document.getElementById("is-virtual-gift-card")?.value == "true" ?? false;

            if (!modal || !reference) return;

            modal.onOpen(async () => {
                await this.fetchGiftCardCustomizationModal(modal, reference, isVirtualGiftCard);
                this.initGiftCardCustomizationModalContent();
            })
        },

        initGiftCardCustomizationModalContent: function () {
            const isVirtualGiftCard = document.getElementById("is-virtual-gift-card")?.value == "true" ?? false;
            const priceSelect = document.getElementById("gift-card-price-select");
            const priceIndicator = document.getElementById("gift-card-price-indicator");
            const modalProductPriceWrapper = document.querySelector(".content-product .content-product__price");
            const modalProductPrice = modalProductPriceWrapper?.querySelector(".final-price");
            const selectedPriceInput = document.getElementById("SelectedPrice");

            priceSelect?.addEventListener("change", () => {
                if (!isVirtualGiftCard) {
                    priceIndicator.innerHTML = priceSelect.value ?? 0 + "<sup>€</sup>";
                }

                if (modalProductPriceWrapper && modalProductPrice) {
                    modalProductPriceWrapper.classList.remove("hidden");
                    modalProductPrice.innerHTML = (priceSelect.value ?? 0) + "<up>€</sup>";
                }

                selectedPriceInput.value = priceSelect.value;
            })
        },

        fetchGiftCardCustomizationModal: async function (modal, reference, isVirtualGiftCard, amount = 0, theme = null) {
            const params = new URLSearchParams({ modal, reference, isVirtualGiftCard, amount, theme })

            try {
                Foundation.libs.common.showPreloader();

                const response = await fetch("/Customization/GetGiftCardCustomizationModal?" + params)
                const data = await response.json();

                if (data.isValid) {
                    if (data.html) {
                        const wrapper = document.getElementById("gift-card-customization-modal-content");

                        wrapper.innerHTML = data.html;
                    }
                } else {
                    throw Error();
                }
            } catch (e) {
                console.error(e);
                const modalWrapper = document.getElementById("gift-card-customization-modal-content");
                this.setErrorInModal(modalWrapper);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        onSuccessVirtualGiftCardModalBack: async function (data) {
            try {
                if (data.isValid) {
                    if (data.html) {
                        const wrapper = document.getElementById("gift-card-customization-modal-content");

                        wrapper.innerHTML = data.html;

                        Foundation.libs.product.initGiftCardCustomizationModalContent();
                    }
                } else {
                    throw Error();
                }
            } catch (e) {
                console.error(e);
                const modalWrapper = document.getElementById("gift-card-customization-modal-content");
                Foundation.libs.product.setErrorInModal(modalWrapper);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        setErrorInModal: function (modalWrapper, message = "Une erreur s'est produite, veuillez ressayer") {
            modalWrapper.innerHTML = `
            <div class="maty-modal__header">
                <div class="maty-modal__close">
                    <button class="button -link close-modal">
                        <img src="/images/product/refonte/close_modal.svg" title="Fermer la pop-in">
                    </button>
                </div>
            </div>
            <div class="maty-modal__content content"><p class="content__error -error">${message}</p>`;

            const closeButton = modalWrapper.querySelector(".close-modal");
            const modal = modalWrapper.closest(".maty-modal")?.modal;

            modal?.initFooter();

            closeButton.addEventListener("click", () => modal.close());
        },

        handleVirtualGiftCardThemeClick: function (code) {
            const modalEl = document.getElementById("gift-card-customization-modal-content");
            const modalProductImageEl = modalEl.querySelector(".content-product__image img");
            const imgSrc = modalProductImageEl.src;
            const activeTheme = document.querySelector(".content__theme.-active");
            const clickedTheme = document.querySelector(`.content__theme[data-theme='${code}']`);
            const selectedThemeInputForBackButton = document.getElementById("SelectedTheme");

            const activeCode = activeTheme.getAttribute("data-theme");

            if (activeCode == code) {
                return;
            }

            const newImg = imgSrc.replace(activeCode, code);
            modalProductImageEl.src = newImg;

            activeTheme.classList.remove("-active");
            clickedTheme.classList.add("-active");

            const selectedThemeInput = document.getElementById("selected-theme");
            selectedThemeInput.value = code;

            selectedThemeInputForBackButton.value = code;
        },

        initProductImagesSliders: () => {
            const mainImagesWrapper = document.querySelector(".product-main-images");
            const thumbnailsWrapper = document.querySelector(".product-thumbnails");

            if (!mainImagesWrapper) return;

            const mainSwiperEl = mainImagesWrapper.querySelector(".swiper");
            const thumbnailsSwiperEl = thumbnailsWrapper.querySelector(".swiper");

            const swipers = [mainSwiperEl, thumbnailsSwiperEl];

            let hasError = false;

            swipers.forEach(swp => {
                const swiperWrapper = swp.querySelector(".wrapper");
                const swiperSlides = swiperWrapper.querySelectorAll(".slide");

                if (!swiperSlides || swiperSlides.length < 2) {
                    hasError = true;
                    return;
                };

                swiperWrapper.classList.add("swiper-wrapper");
                Array.from(swiperSlides).forEach(slide => slide.classList.add("swiper-slide"))
            });

            if (hasError) return;

            const cb = () => {
                const thumbnailsSwiper = new Swiper(thumbnailsSwiperEl, {
                    direction: "vertical",
                    loop: true,
                    spaceBetween: 10,
                    slidesPerView: "auto",
                    freeMode: true,
                    watchSlidesProgress: true,
                    centeredSlidesBounds: true,
                });

                const mainSwiper = new Swiper(mainSwiperEl, {
                    loop: true,
                    thumbs: {
                        swiper: thumbnailsSwiper
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    //breakpoints: {
                    //    1500: {
                    //        pagination: null
                    //    }
                    //},
                    on: {
                        slideChangeTransitionEnd: (e) => {
                            const activeSlide = e.el.querySelector(".swiper-slide-active");
                            if (activeSlide.classList.contains("swiper-360")) {
                                Foundation.libs.product.module360.init();
                            } else {
                                const image = activeSlide.querySelector("img");
 
                                activeSlide.classList.add("-loading");
                                image.setAttribute("src", image.getAttribute("data-src"));
                                image.addEventListener("load", () => { activeSlide.classList.remove("-loading"); })
                            }
                        }
                    }
                });
            }

            if (typeof window.Swiper == typeof undefined) {
                document.addEventListener("SwiperLoaded", () => cb());
            } else {
                cb();
            }

            const attach = (swp, btn, direction) => {
                if (!btn) return;
                btn.classList.add("-init");

                btn.addEventListener("click", () => {
                    if (!swp.initialized) {
                        return;
                    }

                    direction === "next" ? swp.slideNext() : swp.slidePrev();
                });
            };

            swipers.forEach(swp => {
                const swiperNextButton = document.querySelector(".swiper-button-next-custom[data-swiper-id='" + swp.getAttribute("data-swiper-id") + "']");
                const swiperPrevButton = document.querySelector(".swiper-button-prev-custom[data-swiper-id='" + swp.getAttribute("data-swiper-id") + "']");

                if (swiperNextButton) {
                    attach(swp.swiper, swiperNextButton, "next");
                }

                if (swiperPrevButton) {
                    attach(swp.swiper, swiperPrevButton, "prev");
                }
            })
        },

        //initProductImagesLightbox: () => {
        //},

        initRent: function () {
            const productRentContextInput = document.getElementById("product-rent-context");

            if (!productRentContextInput) return;

            const rentWrapper = document.getElementById("rent-wrapper");
            const rentChoices = rentWrapper.querySelectorAll(".rent-choice");
            const _this = this;

            this.rentContext = "rent";

            Array.from(rentChoices).forEach(rentChoice => _this.initRentChoice(rentChoice));
        },

        initRentChoice: function (rentChoice) {
            const _this = this;
            const radio = rentChoice.querySelector(".radio-rent");
            radio.addEventListener("click", (e) => _this.handleRentingChoiceChange(radio));
        },

        handleRentingChoiceChange: function (radio) {
            const value = radio.value;
            const purchaseChoiceWrapper = document.getElementById("purchase-choice-wrapper");
            const rentChoiceWrapper = document.getElementById("rent-choice-wrapper")

            if (value == "rent") {
                rentChoiceWrapper.classList.add("-active");
                purchaseChoiceWrapper.classList.remove("-active");
            } else if (value == "purchase") {
                purchaseChoiceWrapper.classList.add("-active");
                rentChoiceWrapper.classList.remove("-active");
            }

            const productRentContextInput = document.getElementById("product-rent-context");
            productRentContextInput.value = radio.value;

            this.handleRentingContextChange(radio.value);
        },

        handleRentingContextChange: function (value) {
            const _this = this;
            const elDependingOnRentContext = document.querySelectorAll("[data-depend-rent-context]");

            this.rentContext = value;

            elDependingOnRentContext.forEach(el => {
                if (el.getAttribute("data-depend-rent-context") == value) {
                    _this.show(el);
                } else {
                    _this.hide(el);
                }
            })
        },

        initModule360: () => {
            Foundation.libs.product.module360 = new Module360("#module-360");
        },

        initMobileBottom: function () {
            const _this = this;

            const mobileBottomBase = document.querySelector(".mobile-bottom-base");
            const mobileBottomEl = document.querySelector(".mobile-bottom");
            const bottomDimensions = mobileBottomEl?.getBoundingClientRect() ?? 0;
            const pageHeight = window.innerHeight;

            if (!mobileBottomBase || !mobileBottomEl) return;

            const hellobarWrapper = document.querySelector(".hellobars");
            const headerWrapper = document.querySelector(".header-global-content");

            const headerHeight = hellobarWrapper?.clientHeight ?? 0 + headerWrapper?.clientHeight ?? 0;

            document.addEventListener("scroll", (e) => {
                const baseDimensions = mobileBottomBase?.getBoundingClientRect() ?? 0;

                const isInView = (baseDimensions.top + bottomDimensions.height < pageHeight) && (baseDimensions.top > headerHeight);

                if (isInView) {
                    mobileBottomEl.classList.add("hidden");
                } else if (mobileBottomEl.classList.contains("hidden") && _this.rentContext != "rent") {
                    mobileBottomEl.classList.remove("hidden");
                }
            })
        },

        initSizePickers: function () {
            const variantTypeInput = document.getElementById("variant-type");
            const productReferenceInput = document.getElementById("product-reference");

            const _this = this;

            let variantType = null;

            if (variantTypeInput) {
                variantType = variantTypeInput.value;
            }

            let productReference = null;

            if (productReferenceInput) {
                productReference = productReferenceInput.value;
            }

            const variantsPickers = document.querySelectorAll(`select[name="product-size-picker"]`);

            if (variantsPickers == null || variantsPickers.length == 0) return;

            variantsPickers.forEach(picker => {
                picker.addEventListener("change", async function () {
                    const selectedValue = picker.value;

                    const params = new URLSearchParams({
                        reference: productReference,
                        variant: selectedValue,
                        variantType: variantType,
                    })

                    try {
                        Foundation.libs.common.showPreloader();

                        const response = await fetch("/ProductAction/SetSelectedVariant?" + params);
                        const data = await response.json();

                        if (data.isValid) {
                            if (data.htmlInformations) {
                                const informationsWrapper = document.getElementById("product-informations");

                                informationsWrapper.replaceWith(
                                    document.createRange().createContextualFragment(data.htmlInformations)
                                );

                                _this.initInformations();
                            }

                            if (data.htmlImages) {
                                const imagesWrapper = document.getElementById("product-images");

                                imagesWrapper.replaceWith(
                                    document.createRange().createContextualFragment(data.htmlImages)
                                );

                                _this.initImages();
                            }

                        } else {
                            throw new Error();
                        }
                    } catch (e) {
                        const errorWrapper = document.getElementById("size-picker-error");
                        errorWrapper.innerText = "Une erreur s'est produite";
                        console.error(e);
                    } finally {
                        Foundation.libs.common.hidePreloader();
                    }
                })
            })
        },

        //#region customization
        initCustomizationModal: function () {
            if (this.hasCustomizationModalBeenInitialized) return;

            const modalEl = document.getElementById("product-customization-modal");
            const modal = modalEl ? modalEl.modal : null;

            if (modal) {
                const reference = document.getElementById("product-reference")?.value;
                const variant = document.getElementById("product-selected-variant")?.value ?? "";

                modal.onOpen(async () => { await this.fetchCustomizationModalData(modal, reference, variant) })

                this.hasCustomizationModalBeenInitialized = true;
            }
        },

        openCustomizationModalForMandatoryCustomization: async function () {
            const modal = document.getElementById("product-customization-modal").modal;

            modal.onOpen(async (modalInstance) => {
                const string = await Foundation.libs.matyWeglot.adaptStringToLang("La personnalisation de ce produit est obligatoire.");
                modalInstance.element.querySelector(".customization-message").innerHTML = `<p>${string}</p>`;
            });

            await modal.open();
        },

        initEditCustomizationButtons: function () {
            const buttonsEl = document.querySelectorAll(".customization-item__edit[data-modal-id]");
            const buttons = Array.from(buttonsEl);

            if (buttons && buttons.length > 0) {
                buttons.forEach((button) => {
                    button.addEventListener("click", () => {
                        const modalId = button.getAttribute("data-modal-id");
                        const modalEl = document.getElementById(modalId);
                        const modal = modalEl.modal;

                        const modalPage = button.id;

                        if (modalPage == "" || modalPage == "homepage") {
                            modal.open();
                        } else {
                            this.getCustomizationStep(button);
                        }
                    })
                })
            }
        },

        initDeleteCustomizationButtons: function () {
            const buttonsEl = document.querySelectorAll(".customization-item__delete");
            const buttons = Array.from(buttonsEl);
            const _this = this;

            if (buttons && buttons.length > 0) {
                buttons.forEach((button) => {
                    button.addEventListener("click", (event) => {
                        event.stopPropagation();

                        const customizationType = button.getAttribute("data-customization-type");

                        if (customizationType == "gift-card") {
                            _this.deleteGiftCardCustomization();
                        } else {
                            const location = button.getAttribute("data-location-code");
                            _this.deleteCustomizationFromLocation(location);
                        }
                    })
                })
            }
        },

        deleteGiftCardCustomization: async function () {
            const reference = document.getElementById("product-reference").value;

            try {
                Foundation.libs.common.showPreloader();
                const response = await fetch("/customization/DeleteGiftCardCustomization?reference=" + reference, {
                    method: "POST"
                });

                const data = await response.json();
                if (data.isValid) {
                    if (data.html) {
                        const informationsWrapper = document.getElementById("product-informations");

                        informationsWrapper.replaceWith(
                            document.createRange().createContextualFragment(data.html)
                        );

                        this.initInformations();
                    }
                } else {
                    throw new Error("");
                }
            } catch (e) {
                const error = document.querySelector(".customization-wrapper-error");
                error.innerText = "Une erreur s'est produite";
                console.error(e);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        fetchCustomizationModalData: async function (modal, reference, variant = "") {
            const wrapper = modal.element.querySelector("#customization-modal-content")

            try {
                Foundation.libs.common.showPreloader();

                const params = new URLSearchParams({ reference, variant })

                const response = await fetch(`/customization/GetProductCustomizationModal?${params}`);
                const data = await response.json();

                if (data.isValid) {
                    wrapper.innerHTML = data.html;

                    if (data.redirectionPage == "Homepage") {
                        this.initHomeCustomizationPage();
                    } else if (data.isRedirected) {
                        if (data.redirectionPage == "Text") {
                            this.initTextStep(wrapper);
                        }
                        else if (data.redirectionPage == "Pictograms") {
                            this.initPictogramsStep();
                        }
                    }

                    modal.reinitContent();
                    modal.scrollToTop();
                } else if (data.needVariant && data.variantError) {
                    const errorWrapper = document.getElementById("size-picker-error");
                    errorWrapper.innerText = data.variantError;

                    modal.close(false);
                } else {
                    throw new Error()
                }
            } catch (e) {
                this.setErrorInModal(wrapper);
                console.error(e);
            } finally {
                Foundation.libs.common.hidePreloader();
            }

        },

        getCustomizationStep: function (activator) {
            if (!activator) return;

            const id = activator.id;
            const locationCode = activator.getAttribute("data-location-code") ?? "";
            const modalEl = document.querySelector("#product-customization-modal");
            const modal = modalEl.modal;

            switch (id) {
                case "text":
                    this.getTextCustomizationStep(locationCode, modal);
                    break;

                case "pictograms":
                    this.getPictogramsCustomizationStep(locationCode, modal);
                    break;

                case "manual":
                    this.getManualCustomizationStep(locationCode, modal);
                    break;

                default:
                    if (activator.getAttribute("data-return") && activator.getAttribute("data-return") == "homepage") {
                        const reference = document.getElementById("product-reference").value;
                        const variant = document.getElementById("product-selected-variant")?.value ?? "";
                        this.fetchCustomizationModalData(modal, reference, variant);
                    }
            }
        },

        getTextCustomizationStep: async function (locationCode, modal) {
            const reference = document.getElementById("product-reference").value;
            const params = new URLSearchParams({ reference, locationCode });
            const wrapper = document.getElementById("customization-modal-content")

            try {
                Foundation.libs.common.showPreloader();

                modal.open(false);

                const response = await fetch(`/customization/GetTextCustomizationStep?${params}`);
                const data = await response.json();

                if (data.isValid && data.html) {
                    wrapper.innerHTML = data.html;
                    this.initTextStep(wrapper);

                    modal.reinitContent();
                    modal.scrollToTop();
                } else {
                    throw new Error();
                }
            } catch (e) {
                console.error(e);
                this.setErrorInModal(wrapper);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        getManualCustomizationStep: async function (locationCode, modal) {
            const reference = document.getElementById("product-reference").value;
            const params = new URLSearchParams({ reference, locationCode });
            const wrapper = document.getElementById("customization-modal-content");

            try {
                Foundation.libs.common.showPreloader();

                const response = await fetch(`/customization/GetManualCustomizationStep?${params}`);
                const data = await response.json();

                modal.open(false);

                if (data.isValid && data.html) {
                    wrapper.innerHTML = data.html;

                    this.initManualStep(wrapper);

                    modal.reinitContent();
                    modal.scrollToTop();
                } else {
                    throw new Error();
                }
            } catch (e) {
                console.error(e);
                this.setErrorInModal(wrapper);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        getPictogramsCustomizationStep: async function (locationCode, modal) {
            const reference = document.getElementById("product-reference").value;
            const params = new URLSearchParams({ reference, locationCode });
            const wrapper = document.getElementById("customization-modal-content");

            try {
                Foundation.libs.common.showPreloader();

                const response = await fetch(`/customization/GetPictogramsCustomizationStep?${params}`);
                const data = await response.json();

                modal.open(false);

                if (data.isValid && data.html) {
                    wrapper.innerHTML = data.html;

                    this.initPictogramsStep(wrapper);

                    modal.reinitContent();
                    modal.scrollToTop();
                } else {
                    throw new Error();
                }
            } catch (e) {
                console.error(e);
                this.setErrorInModal(wrapper);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        initHomeCustomizationPage: async function () {
            const modal = document.getElementById("product-customization-modal")?.modal;

            if (!modal) {
                console.error("Impossible de trouver la modal de personnalisation");
                return;
            }

            const wrapper = document.getElementById("customization-modal-content");

            if (!wrapper) return;

            const addToCartButton = wrapper.querySelector(".add-to-cart-with-customization");

            if (addToCartButton) {
                addToCartButton.addEventListener("click", async () => {
                    modal.close(false);
                    await this.addProductToCart();
                    Foundation.libs.mastertag.trackAddToCart({ trigger: 'ajout_panier', category: 'personnalisation' });
                })
            }

            const saveCustomizationsButton = wrapper.querySelector(".save-customizations");

            if (saveCustomizationsButton) {
                saveCustomizationsButton.addEventListener("click", () => modal.close(false));
            }

            const customizationTiles = wrapper.querySelectorAll(".customization-tile");

            if (customizationTiles && customizationTiles.length > 0) {
                Array.from(customizationTiles).forEach(tile => {
                    tile.addEventListener("click", () => this.getCustomizationStep(tile));
                })
            }

            const editCustomizationButtons = wrapper.querySelectorAll(".customization-location__edit");

            if (editCustomizationButtons && editCustomizationButtons.length > 0) {
                Array.from(editCustomizationButtons).forEach(button => {
                    button.addEventListener("click", () => this.getCustomizationStep(button));
                })
            }

            const deleteCustomizationButtons = wrapper.querySelectorAll(".customization-location__delete");

            if (deleteCustomizationButtons && deleteCustomizationButtons.length > 0) {
                Array.from(deleteCustomizationButtons).forEach(button => {
                    const locationCode = button.getAttribute("data-location-code");
                    button.addEventListener("click", () => this.deleteCustomizationFromLocation(locationCode));
                })
            }
        },

        initAnyCustomizationStep: function () {
            const modalEl = document.getElementById("product-customization-modal");

            if (!modalEl) return;

            const saveCustomizationButton = modalEl.querySelector(".save-customization");

            if (saveCustomizationButton) {
                const type = saveCustomizationButton.getAttribute("data-customization-type");
                saveCustomizationButton.addEventListener("click", () => this.saveCustomization(type));
            }
        },

        initTextStep: function (wrapper) {
            this.initAnyCustomizationStep();

            const modal = document.getElementById("product-customization-modal").modal;
            const footer = document.querySelector("#product-customization-modal .modal-footer");
            const hasPreview = document.getElementById("has-preview").value == "True";

            const inputs = wrapper.querySelectorAll(".customization-text__input");
            const previewWrapper = document.querySelector(".customization-preview");
            const svgTextComponents = previewWrapper?.querySelectorAll("text") ?? [];
            const fakePreviewText = previewWrapper?.querySelector(".fake-preview-text");
            const firstPrice = document.getElementById("customization-first-price")?.value;
            const zoneAdditionalPrice = document.getElementById("zone-additionnal-price")?.value;
            const customizationPriceIndicator = document.getElementById("customization-price-indicator");
            let customizedZonesIds = [];

            inputs.forEach(input => {
                const id = input.id;
                const textId = input.getAttribute("data-text-id") ?? null;
                const charactersCounter = wrapper.querySelector(`.characters-count[data-input-id="${id}"]`);
                const svgText = textId ? wrapper.querySelector(`#${textId}`) : null;
                const providedTextInput = wrapper.querySelector(`.provided-text[data-input-id='${id}'`);

                const preview = () => {
                    // On vient juste reformater
                    let value = input.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ0-9 .,;:!?'"()\-/+&%€$@#°]/g, '');

                    if (value.length > input.maxLength) {
                        value = value.substring(0, input.maxLength);
                    }

                    const count = value.length;

                    input.value = value;

                    charactersCounter.innerText = count;

                    providedTextInput.value = value;

                    if (hasPreview && svgText) {
                        svgText.textContent = input.value;
                    } else if (fakePreviewText) {
                        if (input.getAttribute("data-special-iteration")) {
                            const iteration = input.getAttribute("data-special-iteration");
                            let specialFakePreviewText = document.querySelector(`.customization-preview.-fake[data-special-iteration='${iteration}'] .fake-preview-text`);

                            if (specialFakePreviewText) {
                                specialFakePreviewText.innerText = value;
                            }
                        } else if (fakePreviewText) {
                            fakePreviewText.innerText = value;
                        }
                    }

                    if (zoneAdditionalPrice) {
                        if (input.value != "") {
                            if (customizedZonesIds.find(el => el == input.id) == undefined) {
                                customizedZonesIds.push(input.id);
                            }
                        } else {
                            customizedZonesIds = customizedZonesIds.filter(el => el != input.id);
                        }

                        const price = parseInt(zoneAdditionalPrice);

                        if (customizationPriceIndicator) {
                            if (customizedZonesIds.length > 1) {
                                customizationPriceIndicator.innerHTML = "+" + price + " €";
                            } else {
                                customizationPriceIndicator.innerHTML = "+" + firstPrice + " €";
                            }
                        }
                    }

                    if (input.value != "") {
                        footer.classList.remove("hidden");

                        modal.initFooter();
                    }
                }

                preview();

                input.addEventListener("input", () => preview());
                input.addEventListener("focus", () => {
                    if (window.matchMedia("(max-width: 1024px)").matches) {
                        const customizationAnchor = document.getElementById("customization-anchor");
                        customizationAnchor.scrollIntoView({ block: "start" })
                    }
                })
            })

            const typographySelect = wrapper.querySelector("#customization-select");
            const providedTypographyInput = wrapper.querySelector(".provided-typography");

            if (!typographySelect) return;

            typographySelect.addEventListener("change", function (e) {
                const selectedTypography = typographySelect.value;
                const fontFamily = `'f${selectedTypography}', Arial, sans-serif`;
                const selectedOption = typographySelect.selectedOptions[0];
                const isCapsOnly = selectedOption.getAttribute("data-caps-only") === "True";

                providedTypographyInput.value = selectedTypography;

                typographySelect.style.setProperty('font-family', fontFamily, 'important');

                if (hasPreview) {
                    Array.from(svgTextComponents).forEach(function (text) {
                        text.setAttribute("font-family", fontFamily);

                        if (isCapsOnly) {
                            text.style.textTransform = "uppercase";
                        } else {
                            text.style.textTransform = "inherit";
                        }
                    });
                } else {
                    const fakePreviewTexts = document.querySelectorAll(".fake-preview-text");

                    Array.from(fakePreviewTexts).forEach(fakePreviewText => {
                        fakePreviewText.style.fontFamily = fontFamily;

                        if (isCapsOnly) {
                            fakePreviewText.style.textTransform = "uppercase";
                        } else {
                            fakePreviewText.style.textTransform = "inherit";
                        }
                    })
                }
            })
        },

        initManualStep: async function (wrapper) {
            this.initAnyCustomizationStep();

            const modal = document.getElementById("product-customization-modal")?.modal;
            const uploadLabel = document.getElementById("manual-customization-upload-label");
            const footer = wrapper.querySelector(".modal-footer");

            const fileInput = new FileInput("#manual-customization-upload-button", {
                onChange: function () {
                    uploadLabel.innerText = "Télécharger un autre dessin";
                    footer.classList.remove("hidden");

                    if (modal) {
                        modal.initFooter();
                    }
                },
                onRemove: function () {
                    uploadLabel.innerText = "Télécharger un dessin";
                    footer.classList.add("hidden");

                    if (modal) {
                        modal.initFooter();
                    }
                }
            })

            const fileNameInput = document.getElementById("customization-file-name");

            if (fileNameInput) {
                const fileName = fileNameInput.value;
                const productReference = document.getElementById("product-reference").value;
                const locationCode = document.getElementById("modal-location-code").value;

                const params = new URLSearchParams({ productReference, locationCode });

                const previewDiv = document.querySelector("[data-preview-for='manual-customization-upload-button']");

                if (fileName.includes(".pdf")) {
                    const iframe = document.createElement("iframe");
                    iframe.src = "/customization/getManualCustomizationFile?" + params;
                    previewDiv.appendChild(iframe);
                } else {
                    const img = document.createElement("img");
                    img.src = "/customization/getManualCustomizationFile?" + params;
                    previewDiv.appendChild(img);
                }

                const removeFileButton = document.getElementById("remove-manual-customization-file");

                const _this = this;

                removeFileButton.addEventListener("click", async function () {
                    _this.deleteCustomizationFromLocation(locationCode)
                })
            }
        },

        initPictogramsStep: function (wrapper) {
            this.initAnyCustomizationStep();

            const swiper = new Swiper(wrapper.querySelector(".swiper"), {
                slidesPerGroup: 4,
                slidesPerView: 4,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                    addIcons: false
                },
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets",
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<b class="' + className + '">' + (index + 1) + '</b>';
                    }
                }
            });

            const _this = this;
            const pictogramCategoriesSelect = document.getElementById("pictogram-category-select");

            pictogramCategoriesSelect.addEventListener("change", function () {
                const selectedCategory = pictogramCategoriesSelect.value;
                _this.renderPictograms(wrapper, selectedCategory);

                swiper.slideTo(1);
            })

            this.renderPictograms(wrapper);
        },

        renderPictograms: function (wrapper, category = null) {
            const pictogramsData = document.getElementById("pictograms-data").getAttribute("data-pictograms");
            const pictograms = JSON.parse(pictogramsData);
            const providedPictogramInput = wrapper.querySelector("#provided-pictogram");
            const providedPictogram = providedPictogramInput?.value;

            const filteredPictograms = !category
                ? pictograms
                : pictograms.filter(p => p.CategoryCode == category);

            const swiper = wrapper.querySelector(".swiper").swiper;
            swiper.wrapperEl.innerHTML = "";

            for (let i = 0; i < filteredPictograms.length; i += 2) {
                const slide = document.createElement('div');
                slide.className = 'swiper-slide';

                for (let j = 0; j < 2; j++) {
                    if (filteredPictograms[i + j]) {
                        const pictogram = filteredPictograms[i + j];
                        const isSelected = providedPictogram && providedPictogram == pictogram.PictoPictureName;

                        slide.innerHTML += `
                            <div class="customization-pictogram ${isSelected ? '-active' : ''}"
                                 data-name="${pictogram.PictoPictureName}" data-label="${pictogram.PictoPictureLabel}" data-path="${pictogram.ReferencePath}" data-image-url="/Images/Gravure/pictos/${pictogram.PictoPictureName}.png" data-category="${pictogram.CategoryCode}">
                                <img class="customization-pictogram__image" src="/Images/Gravure/pictos/${pictogram.PictoPictureName}_preview.png" />
                            </div>
                        `;
                    }
                }

                swiper.wrapperEl.appendChild(slide);
            }

            const modal = document.getElementById("product-customization-modal").modal;
            const footer = document.querySelector("#customization-modal-content .modal-footer");
            const previewWrapper = document.querySelector(".customization-preview");
            const pictogramsEl = wrapper.querySelectorAll(".customization-pictogram");

            Array.from(pictogramsEl).forEach(pictogram => {
                pictogram.addEventListener("click", () => {
                    const name = pictogram.getAttribute("data-name");
                    const svgPath = pictogram.getAttribute("data-path");
                    const imgUrl = pictogram.getAttribute("data-image-url");

                    providedPictogramInput.value = name;

                    const svgImageComponent = previewWrapper.querySelector("#" + svgPath);
                    svgImageComponent.setAttribute("href", imgUrl);

                    const activePictogram = wrapper.querySelector(".customization-pictogram.-active");

                    if (activePictogram) {
                        activePictogram.classList.remove("-active");
                    }

                    pictogram.classList.add("-active");

                    if (footer) {
                        footer.classList.remove("hidden");
                        modal.initFooter();
                    }
                })
            })

            if (providedPictogramInput.value != null) {
                const activePictogram = wrapper.querySelector(".customization-pictogram.-active");
                if (activePictogram) activePictogram.click();
            }

            swiper.update();
        },

        returnToView: function () {
            const previousView = document.querySelector("#modal-previous-view").value;
            const previousLocationCode = document.querySelector("#modal-previous-location-code").value;

            const activator = document.createElement("input");
            activator.setAttribute("data-location-code", previousLocationCode);
            activator.id = previousView.toLowerCase();

            this.getCustomizationStep(activator);
        },

        saveCustomization: async function (customizationType) {
            const referenceInput = document.getElementById("product-reference");
            const hasPreviewInput = document.getElementById("has-preview");
            const locationCodeInput = document.querySelector("#modal-location-code");

            let requestData;
            const formData = new FormData();

            if (customizationType == "Text") {
                const textInputs = document.querySelectorAll(".customization .provided-text");
                const typographyInput = document.querySelector(".customization .provided-typography");

                requestData = {
                    Zones: [],
                    Font: typographyInput.value,
                    LocationCode: locationCodeInput.value,
                    Reference: referenceInput.value,
                    HasPreview: hasPreviewInput.value
                };

                Array.from(textInputs).forEach(input => {
                    const zoneId = input.getAttribute("data-zone-id");
                    const providedText = input.value;

                    if (providedText != "") {
                        requestData.Zones.push({ ZoneId: zoneId, ProvidedText: providedText })
                    }
                })
            } else if (customizationType == "Pictograms") {
                const pictogramInput = document.getElementById("provided-pictogram");

                requestData = {
                    Zones: [
                        {
                            ZoneId: pictogramInput.getAttribute("data-zone-id"),
                            ProvidedPictogram: pictogramInput.value
                        }
                    ],
                    LocationCode: locationCodeInput.value,
                    Reference: referenceInput.value,
                    HasPreview: hasPreviewInput.value
                };
            } else if (customizationType == "Manual") {
                const fileUploadInput = document.getElementById("manual-customization-upload-button");
                const files = fileUploadInput.files;

                if (files.length == 0) return;

                const file = files[0];

                formData.append("file", file);
                formData.append("reference", referenceInput.value);
                formData.append("locationCode", locationCodeInput.value);
                formData.append("hasPreview", hasPreviewInput.value);

                requestData = {
                    Zones: [],
                    Font: null,
                    LocationCode: locationCodeInput.value,
                    Reference: referenceInput.value,
                    HasPreview: hasPreviewInput.value,
                    File = formData
                };
            }

            if (customizationType != "Manual" && requestData.Zones.length == 0) {
                const activator = document.createElement("input");
                activator.setAttribute("data-return", "homepage");

                this.getCustomizationStep(activator);

                return;
            }

            try {
                Foundation.libs.common.showPreloader();

                let request = {
                    url: null,
                    data: null
                }

                if (customizationType == "Manual") {
                    request.url = "/Customization/SaveManualCustomization";
                    request.data = {
                        method: "POST",
                        body: formData
                    };
                } else {
                    request.url = "/Customization/SaveCustomization";
                    request.data = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(requestData)
                    };
                }

                const response = await fetch(request.url, request.data);

                const data = await response.json();

                const modal = document.getElementById("product-customization-modal")?.modal;

                if (data.isValid) {

                    if (data.customizationItemsHtml) {
                        const customizationsWrapper = document.getElementById("product-customizations-content");

                        if (customizationsWrapper) {
                            customizationsWrapper.innerHTML = data.customizationItemsHtml;
                            this.initDeleteCustomizationButtons();
                            this.initEditCustomizationButtons();
                        }
                    }

                    if (data.addToCartHtml) {
                        const addToCartWrapper = document.getElementById("add-to-cart-wrapper");
                        const addToCartMobileWrapper = document.getElementById("add-to-cart-mobile-wrapper");

                        addToCartWrapper.innerHTML = data.addToCartHtml;
                        addToCartMobileWrapper.innerHTML = data.addToCartHtml;

                        this.initAddToCartButton();
                    }

                    if (data.masterTag) {
                        Foundation.libs.common.refreshMasterTagData(data.masterTag);
                        Foundation.libs.common.refreshMasterTag();
                    }

                    Foundation.libs.mastertag.trackSaveCustomization();

                    modal.scrollToTop();

                    if (data.closeModal) {
                        const wrapper = document.getElementById("product-customizations-content");

                        if (data.html) {
                            wrapper.innerHTML = data.html;
                        }

                        if (modal) {
                            modal.close(false);
                        }

                        this.initDeleteCustomizationButtons();
                        this.initEditCustomizationButtons();
                    } else if (data.html) {
                        const wrapper = document.getElementById("customization-modal-content");
                        wrapper.innerHTML = data.html;

                        if (data.redirectionPage == "Homepage") {
                            this.initHomeCustomizationPage()
                        }

                        if (modal) {
                            modal.reinitContent();
                        }
                    }
                } else {
                    if (data.error && data.error != "") {
                        const errorWrapper = document.querySelector(".customization-modal-error");
                        errorWrapper.innerText = data.error;
                    } else {
                        throw new Error();
                    }
                }
            } catch (e) {
                console.error(e);
                const wrapper = document.getElementById("customization-modal-content");
                this.setErrorInModal(wrapper);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        deleteCustomizationFromLocation: async function (locationCode) {
            const modal = document.getElementById("product-customization-modal")?.modal;

            try {
                Foundation.libs.common.showPreloader();

                const productReference = document.getElementById("product-reference")?.value;
                const variant = document.getElementById("product-selected-variant")?.value ?? "";
                const params = new URLSearchParams({ productReference, locationCode });

                if (productReference) {
                    const response = await fetch("/Customization/RemoveCustomizationFromLocation?" + params, {
                        method: "POST"
                    });

                    const data = await response.json();

                    if (data.isValid) {
                        if (modal.isModalOpen != undefined && modal.isModalOpen == true) {
                            await this.fetchCustomizationModalData(modal, productReference, variant);
                        }

                        if (data.html) {
                            const customizationsWrapper = document.getElementById("product-customizations-content");
                            if (customizationsWrapper) customizationsWrapper.innerHTML = data.html;

                            this.initDeleteCustomizationButtons();
                            this.initEditCustomizationButtons();

                            const activator = document.querySelector("[data-modal-id='product-customization-modal']");
                            activator.addEventListener("click", () => modal.open());
                        }

                        if (data.masterTag) {
                            Foundation.libs.common.refreshMasterTagData(data.masterTag);
                            Foundation.libs.common.refreshMasterTag();
                        }

                        if (data.addToCartHtml) {
                            const addToCartWrapper = document.getElementById("add-to-cart-wrapper");
                            const addToCartMobileWrapper = document.getElementById("add-to-cart-mobile-wrapper");

                            addToCartWrapper.innerHTML = data.addToCartHtml;
                            addToCartMobileWrapper.innerHTML = data.addToCartHtml;

                            this.initAddToCartButton();
                            modal.scrollToTop();
                        }
                    } else {
                        throw Error();
                    }
                }
            } catch (e) {
                console.error(e);
                const wrapper = document.getElementById("customization-modal-content");
                this.setErrorInModal(wrapper)
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },
        //#endregion


        //#region Click and collect / E-réservation
        initClickAndCollect: function () {
            const clickAndCollectModalEl = document.getElementById("click-and-collect-modal");

            if (!clickAndCollectModalEl) return;

            setTimeout(() => { }, 1);

            const modal = clickAndCollectModalEl ? clickAndCollectModalEl.modal : null;

            const variantType = document.getElementById("variant-type")?.value ?? "";
            const sizingCode = document.getElementById("sizing-code")?.value ?? "";
            const selectedVariant = document.getElementById("product-selected-variant")?.value ?? "";

            if (modal) {
                this.hasClickAndCollectModalBeenInitialized = true;
                // TODO PDT : Méthode globale pour récupérer la référence du produit, la variante sélectionnée, etc...
                const productReference = document.getElementById("product-reference").value;

                modal.onOpen(() => this.fetchClickAndCollectContent(modal, "", "", productReference, selectedVariant, variantType, sizingCode), true);
            }
        },

        fetchClickAndCollectContent: async function (modal, research = "", selectedStore = "", productReference = "", productVariant = "", variantType = "", sizingCode = "") {
            const params = new URLSearchParams({ research, selectedStore, productReference, productVariant, variantType, sizingCode });
            const wrapper = document.getElementById("click-and-collect-modal-wrapper");
            const locationError = document.getElementById('location-error')

            try {
                Foundation.libs.common.showPreloader();
                const response = await fetch("/ClickAndCollect/GetClickAndCollectModalContent?" + params);
                const data = await response.json();

                if (data.isValid && data.html != null) {
                    wrapper.innerHTML = data.html;

                    this.updateClickAndCollectBackButtonVisibility();
                    this.initCloseButtonClickAndCollectModal();

                    Foundation.libs.mastertag.trackClickAndCollectModal();
                } else {
                    if (data.redirectToVariants) {
                        modal.close();

                        const sizeWrapper = document.querySelector(".product-sizes");
                        const sizePickerWrapper = sizeWrapper.querySelector(".product-sizes__wrapper");

                        if (!sizePickerWrapper.classList.contains("-has-error")) {
                            sizePickerWrapper.classList.add("-has-error");
                            const textElement = document.createElement("p");
                            textElement.classList.add("-error");
                            textElement.innerText = "Veuillez choisir la taille de votre produit";

                            sizeWrapper.appendChild(textElement);
                        }

                        sizePickerWrapper.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                    }
                    else if (data.Erreur && locationError) {
                        locationError.innerText = data.Erreur;

                        //on supprime les précédents résultats
                        const elements = document.getElementsByClassName('content__result');
                        for (let el of elements) {
                            el.innerHTML = '';
                        }
                    }
                    else {
                        throw new Error();
                    }
                }

                this.initClickAndCollectModal(modal);
            } catch (e) {
                console.error(e);
                this.setErrorInModal(wrapper);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        initClickAndCollectModal: function (modal) {
            const jewelleriesSelect = modal.element.querySelector("#click-and-collect-jeweleries-select");
            const inputWrapperForm = modal.element.querySelector(".input-wrapper");
            const input = inputWrapperForm.querySelector("#jewellery-search-input");
            const locationButton = modal.element.querySelector(".location-button");

            const productReference = document.getElementById("product-reference").value;
            const productVariant = document.getElementById("product-selected-variant")?.value ?? "";
            const variantType = document.getElementById("variant-type")?.value ?? "";
            const sizingCode = document.getElementById("sizing-code")?.value ?? "";

            const _this = this;

            jewelleriesSelect.addEventListener("change", function () {

                const selectedStore = jewelleriesSelect.value;
                _this.fetchClickAndCollectContent(modal, "", selectedStore, productReference, productVariant, variantType, sizingCode);
            })

            inputWrapperForm.addEventListener("submit", function (e) {
                e.preventDefault();

                const research = input.value;

                _this.fetchClickAndCollectContent(
                    modal,
                    research,
                    "",
                    productReference,
                    productVariant,
                    variantType,
                    sizingCode
                );
            });

            locationButton.addEventListener("click", function () {
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        _this.handleClickAndCollectLocation(position);
                    }, (error) => {
                        // Code d'erreur 1 signifie que l'utilisateur a refusé les données de géoloc, soit dans les paramètres de l'appareil, soit dans le navigateur
                        if (error.code == 1) {
                            alert("Veuillez activer les données de géolocalisation pour utiliser cette fonction");
                        }
                    });
            })
        },

        handleClickAndCollectButtonClick: async function (selectedStore) {
            try {
                Foundation.libs.common.showPreloader();

                const productReference = document.getElementById("product-reference")?.value;

                if (productReference == null) {
                    throw new Error("Impossible de récupérer la référence du produit");
                }

                const selectedVariant = document.getElementById("product-selected-variant")?.value ?? "";

                const params = new URLSearchParams({ reference: productReference, variant: selectedVariant, isClickAndCollect: true, storeCode: selectedStore });

                const response = await fetch("/productaction/AddProductToCart?" + params, {
                    method: "POST"
                });

                const data = await response.json();

                if (data.isValid) {
                    const modal = document.getElementById("click-and-collect-modal")?.modal;
                    if (modal) modal.close();

                    if (data.productCount) {
                        const cartPictogram = document.getElementById("cart-pictogram");
                        let productCountEl = document.querySelector("#cart-pictogram .product-nb");

                        if (!productCountEl) {
                            const el = document.createElement("span");
                            el.classList.add("product-nb");

                            cartPictogram.appendChild(el);

                            productCountEl = document.querySelector("#cart-pictogram .product-nb");
                        }

                        productCountEl.innerText = data.productCount;
                    }

                    if (data.masterTag) {
                        Foundation.libs.common.refreshMasterTagData(data.masterTag);
                        Foundation.libs.common.refreshMasterTag();
                    }

                    Foundation.libs.mastertag.trackAddToCart({ trigger: 'ajout_panier', category: 'retrait bijouterie' });

                    await this.getAddToCartModal();
                } else {
                    const errorWrapper = document.getElementById("click-and-collect-error");
                    errorWrapper.innerText = data.error;
                }
            } catch (e) {
                console.error(e);

                // TODO PDT : Ajouter une méthode de gestion des erreurs qui ajoute un message dans la modal (passée en parametre) qui est appelée dans tous les catch
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        handleEReservationButtonClick: async function (selectedStore, selectedVariant = "") {
            try {
                Foundation.libs.common.showPreloader();

                const modal = document.getElementById("click-and-collect-modal").modal;

                const productReference = document.getElementById("product-reference")?.value;

                if (selectedVariant == null || selectedVariant == "") {
                    selectedVariant = document.getElementById("product-selected-variant")?.value ?? "";
                }

                const params = new URLSearchParams({ selectedStore, productReference, selectedVariant })
                const response = await fetch("/ereservation/GetEReservationModalContent?" + params);
                const data = await response.json();

                if (data && data.isValid) {
                    if (data.html != "") {
                        const wrapper = document.getElementById("click-and-collect-content");
                        wrapper.innerHTML = data.html;

                        const modalWrapper = document.getElementById("click-and-collect-modal-wrapper");
                        const title = modalWrapper.querySelector(".maty-modal__header h3");

                        title.innerText = await Foundation.libs.matyWeglot.adaptStringToLang("Réserver et essayer");

                        Foundation.libs.mastertag.trackEReservation("demande e-reservation");

                        this.updateClickAndCollectBackButtonVisibility();
                        this.initCloseButtonClickAndCollectModal();

                        modal.initFooter();
                        modal.scrollToTop();
                    }
                } else {
                    const errorWrapper = document.getElementById("click-and-collect-error");
                    errorWrapper.innerText = "Une erreur s'est produite";
                }
            } catch (e) {
                console.error(e);
                const errorWrapper = document.getElementById("click-and-collect-error");
                errorWrapper.innerText = "Une erreur s'est produite";
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        handleClickAndCollectLocation: async function (location) {
            const modal = document.getElementById("click-and-collect-modal").modal;
            const latitude = location.coords.latitude;
            const longitude = location.coords.longitude;
            const productReference = document.getElementById("product-reference")?.value;
            const productVariant = document.getElementById("product-selected-variant")?.value ?? "";
            const variantType = document.getElementById("variant-type")?.value ?? "";
            const sizingCode = document.getElementById("sizing-code")?.value ?? "";

            const params = new URLSearchParams({ latitude, longitude, productReference, productVariant, variantType, sizingCode });

            try {
                Foundation.libs.common.showPreloader();
                const response = await fetch("/ClickAndCollect/GetClickAndCollectModalContentWithCoords?" + params);

                const data = await response.json();

                if (data.isValid) {
                    if (data.html) {
                        const wrapper = document.getElementById("click-and-collect-modal-wrapper");
                        wrapper.innerHTML = data.html;

                        this.updateClickAndCollectBackButtonVisibility();
                        this.initCloseButtonClickAndCollectModal();
                    }
                } else {
                    const error = document.getElementById("location-error");
                    error.innerText = data.error;
                }

            } catch (e) {
                console.error(e);
            } finally {
                Foundation.libs.common.hidePreloader();
            }

            this.initClickAndCollectModal(modal);
        },

        updateEReservationAvailabilities: function () {
            const select = document.getElementById("e-reservation-variant-select");
            const selectedVariant = select.value;
            const selectedStore = document.getElementById("e-reservation-selected-store")?.value ?? "";
            this.handleEReservationButtonClick(selectedStore, selectedVariant);
        },

        getEReservationModalForm: async function () {
            const wrapper = document.getElementById("click-and-collect-content");
            const modal = document.getElementById("click-and-collect-modal").modal;

            try {
                Foundation.libs.common.showPreloader();

                const productReference = document.getElementById("product-reference")?.value ?? "";
                const selectedStore = document.getElementById("e-reservation-selected-store")?.value ?? "";
                const selectedStoreName = document.getElementById("e-reservation-selected-store-name")?.value ?? "";
                const selectedVariant = document.getElementById("e-reservation-variant-select")?.value ?? "";
                const availabilityDate = document.getElementById("e-reservation-availability-date")?.value ?? "";

                const params = new URLSearchParams({ productReference, selectedStore, selectedStoreName, availabilityDate, selectedVariant });

                const response = await fetch("/ereservation/GetEReservationModelForm?" + params);
                const data = await response.json();

                if (data.isValid && data.html) {
                    wrapper.innerHTML = data.html;

                    Foundation.libs.pcc.initPccs();
                    this.initEReservationCaptcha();

                    this.updateClickAndCollectBackButtonVisibility();
                    this.initCloseButtonClickAndCollectModal();

                    modal.initFooter();
                    modal.scrollToTop();
                } else {
                    throw new Error();
                }
            } catch (e) {
                console.error(e);
                const modalWrapper = document.getElementById("click-and-collect-modal-wrapper");
                this.setErrorInModal(modalWrapper);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        initEReservationCaptcha: function () {
            const refreshButton = document.querySelector("#captcha-row .changeCaptcha");
            if (!refreshButton) return;

            const url = refreshButton.dataset.url;
            const tokenName = refreshButton.dataset.tokenname;
            const tokenInputId = refreshButton.dataset.tokenid;

            refreshButton.style.display = "block";

            refreshButton.addEventListener("click", function (e) {
                e.preventDefault();

                const tokenInput = document.getElementById(tokenInputId);
                if (!tokenInput) return;

                refreshButton.style.display = "none";

                fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    body: new URLSearchParams({
                        [tokenName]: tokenInput.value
                    })
                })
                    .then(() => {
                        refreshButton.style.display = "block";
                    })
                    .catch(() => {
                        refreshButton.style.display = "block";
                    });
            });
        },

        updateClickAndCollectBackButtonVisibility: function () {
            const backWrapper = document.getElementById("modal-back-click-and-collect");
            if (!backWrapper) return;

            const modalPage = document.getElementById("e-reservation-modal-page")?.value ?? "";

            if (modalPage == null || modalPage == "") {
                if (!backWrapper.classList.contains("hidden")) backWrapper.classList.add("hidden");
                return;
            }

            if (modalPage == "Home" || modalPage == "Confirmation") {
                if (!backWrapper.classList.contains("hidden")) backWrapper.classList.add("hidden");
                return;
            }

            if (modalPage == "Store" || modalPage == "Form") {
                if (backWrapper.classList.contains("hidden")) backWrapper.classList.remove("hidden");
                return;
            }
        },

        initCloseButtonClickAndCollectModal: function () {
            const modal = document.getElementById("click-and-collect-modal")?.modal;
            const button = modal.element.querySelector(".button.close-modal");
            button.addEventListener("click", () => modal.close());
        },

        handleClickAndCollectBackButtonClick: function () {
            const modalPage = document.getElementById("e-reservation-modal-page")?.value ?? "";

            if (!modalPage || modalPage == "") return;

            if (modalPage == "Store") {
                const clickAndCollectModalEl = document.getElementById("click-and-collect-modal");
                const modal = clickAndCollectModalEl ? clickAndCollectModalEl.modal : null;
                const variantType = document.getElementById("variant-type")?.value ?? "";
                const sizingCode = document.getElementById("sizing-code")?.value ?? "";
                const selectedVariant = document.getElementById("product-selected-variant")?.value ?? "";
                const productReference = document.getElementById("product-reference").value;

                this.fetchClickAndCollectContent(modal, "", "", productReference, selectedVariant, variantType, sizingCode);
            } else if (modalPage == "Form") {
                const selectedStore = document.getElementById("e-reservation-selected-store")?.value ?? "";
                const selectedVariant = document.getElementById("e-reservation-selected-variant")?.value ?? "";

                this.handleEReservationButtonClick(selectedStore, selectedVariant);
            }
        },

        onSuccessSaveEReservation: function (data) {
            if (data.html && data.html != "") {
                const wrapper = document.getElementById("click-and-collect-content");
                const backButton = document.querySelector("#click-and-collect-modal .modal-back");

                wrapper.innerHTML = data.html;

                if (backButton) {
                    backButton.style.display = "none";
                }

                Foundation.libs.mastertag.trackEReservation("validation e-reservation");
            }
        },

        //#endregion

        onSuccessSaveGiftCardCustomization: async function (data) {
            const modal = document.getElementById("gift-card-customization-modal")?.modal ?? null;

            if (modal == null) {
                Foundation.libs.common.hidePreloader();
                return;
            }

            if (data.isValid) {
                modal.close();
                if (data.html) {
                    const informationsWrapper = document.getElementById("product-informations");

                    informationsWrapper.replaceWith(
                        document.createRange().createContextualFragment(data.html)
                    );

                    // Vu qu'on vient d'un onsuccess d'un ajax.beginForm, on perd la référence du this
                    Foundation.libs.product.initInformations();

                    if (data.addedToCart) {
                        try {
                            await Foundation.libs.product.getAddToCartModal();
                        } catch (e) {
                            console.error(e);
                        }
                    }

                    Foundation.libs.common.hidePreloader();
                }
                else {
                    Foundation.libs.common.hidePreloader();
                }
            } else {
                if (data.html) {
                    const wrapper = document.getElementById("gift-card-customization-modal-content");
                    wrapper.innerHTML = data.html;

                    Foundation.libs.product.initGiftCardCustomizationModalContent();

                    Foundation.libs.common.hidePreloader();
                }

                if (data.closeModal && data.closeModal == true) {
                    modal.close(false);
                }

                if (data.error && data.error != "") {
                    const errorEl = document.getElementById("add-to-cart-error");
                    errorEl.innerText = data.error;
                }
            }

            Foundation.libs.common.hidePreloader();
        },

        onSuccessSaveVirtualGiftCardCustomization: async function (data) {
            const formWrapper = document.getElementById("virtual-gift-card-form");

            if (data.closeModal != null) {
                if (data.closeModal == false) {
                    if (data.htmlForm) {
                        const formWrapper = document.getElementById("virtual-gift-card-form");
                        formWrapper.innerHTML = data.htmlForm;

                        const modal = document.getElementById("gift-card-customization-modal").modal;

                        const backButton = document.querySelector("#gift-card-customization-modal .maty-modal__back");

                        if (backButton) backButton.classList.remove("hidden");

                        modal.initFooter();
                        modal.scrollToTop();
                    }
                } else if (data.closeModal == true) {
                    const modal = document.getElementById("gift-card-customization-modal").modal;

                    if (data.isValid) {
                        if (data.html) {
                            const informationsWrapper = document.getElementById("product-informations");

                            informationsWrapper.replaceWith(
                                document.createRange().createContextualFragment(data.html)
                            );

                            Foundation.libs.product.initInformations();
                        }

                        if (data.addedToCart == null || data.addedToCart == true) {
                            if (data.productCount) {
                                const cartPictogram = document.getElementById("cart-pictogram");
                                let productCountEl = document.querySelector("#cart-pictogram .product-nb");

                                if (!productCountEl) {
                                    const el = document.createElement("span");
                                    el.classList.add("product-nb");

                                    cartPictogram.appendChild(el);

                                    productCountEl = document.querySelector("#cart-pictogram .product-nb");
                                }

                                productCountEl.innerText = data.productCount;
                            }

                            try {
                                await Foundation.libs.product.getAddToCartModal();
                            } catch (e) {
                                console.error(e);
                                const modalWrapper = document.getElementById("gift-card-customization-modal-content");
                                this.setErrorInModal(modalWrapper);
                            }
                        }
                    } else {
                        if (data.message) {
                            const customizationWrapper = document.querySelector(".product-customizations");
                            const errorEl = document.querySelector(".customization-wrapper-error");
                            errorEl.innerText = data.message;
                            customizationWrapper.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                        }
                    }

                    modal.close();
                }
            }

            Foundation.libs.common.hidePreloader();
        },

        addProductToCart: async function () {
            const reference = document.getElementById("product-reference")?.value;
            let variant = document.getElementById("product-selected-variant")?.value ?? "";

            const isClickAndCollect = false;

            const params = new URLSearchParams({ reference, variant, isClickAndCollect });

            let data = null;

            try {
                Foundation.libs.common.showPreloader();

                const response = await fetch("/ProductAction/AddProductToCart?" + params, {
                    method: "POST",
                });

                data = await response.json();

                if (data.isValid) {
                    if (data.html) {
                        const informationsWrapper = document.getElementById("product-informations");

                        informationsWrapper.replaceWith(
                            document.createRange().createContextualFragment(data.html)
                        );

                        this.initInformations();

                        // Dans le cas de la location, si on reset le contenu de la page, la partie "achat" du produit est cachée
                        // donc la modal d'ajout au panier est ouverte mais cachée et donc ça bloque l'écran
                        // donc là on vient choisir le mode "achat" du produit
                        const productRentContextInput = document.getElementById("product-rent-context");

                        if (productRentContextInput) {
                            const purchaseRadio = document.querySelector("input#purchase");
                            purchaseRadio.click();
                        }
                    }

                    if (data.productCount) {
                        const cartPictogram = document.querySelector(".header-entry.cart");
                        let productCountEl = document.querySelector(".header-entry.cart .product-nb");

                        if (!productCountEl) {
                            const p = document.createElement("p");
                            const el = document.createElement("span");
                            el.classList.add("product-nb");

                            p.appendChild(el);

                            const currentPicto = cartPictogram.querySelector("svg").outerHTML;

                            try {
                                const data = await fetch("/navigation/GetCartPicto");
                                const picto = await data.text();

                                if (picto != null && picto != "") {
                                    Array.from(cartPictogram.children).find(el => el.tagName == "svg").remove();

                                    const parser = new DOMParser();
                                    const pictoEl = parser.parseFromString(picto, "text/html").querySelector("svg");

                                    cartPictogram.appendChild(pictoEl);
                                }
                            } catch {
                                if (!cartPictogram.querySelector("svg")) {
                                    cartPictogram.appendChild(currentPicto);
                                }
                            }

                            cartPictogram.appendChild(p);

                            productCountEl = document.querySelector(".header-entry.cart .product-nb");
                        }

                        productCountEl.innerText = data.productCount;
                    }

                    if (data.masterTag) {
                        Foundation.libs.common.refreshMasterTagData(data.masterTag);
                        Foundation.libs.common.refreshMasterTag();
                    }

                    await this.getAddToCartModal();
                } else {
                    const addToCartError = document.getElementById("add-to-cart-error");
                    addToCartError.innerText = data.error;
                }

            } catch (e) {
                console.error(e);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        handleAddGiftCardToCart: async function (response) {
            const data = response.responseJSON;

            if (data.isValid) {
                if (data.html) {
                    const informationsWrapper = document.getElementById("product-informations");

                    informationsWrapper.replaceWith(
                        document.createRange().createContextualFragment(data.html)
                    );

                    Foundation.libs.product.initInformations();
                }

                try {
                    await Foundation.libs.product.getAddToCartModal();
                } catch (e) {
                    console.error(e);
                } finally {
                    Foundation.libs.common.hidePreloader();
                }
            } else {
                Foundation.libs.common.hidePreloader();

                if (data.message) {
                    const customizationWrapper = document.querySelector(".product-customizations");
                    //const errorEl = document.querySelector(".customization-wrapper-error");
                    //errorEl.innerText = data.message;
                    customizationWrapper.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                }

                if (data.error && data.error != "") {
                    const errorEl = document.getElementById("add-to-cart-error");
                    errorEl.innerText = data.error;
                }

                if (data.redirectToCustomization == true) {
                    const modalActivator = document.querySelector(".customizations-item .modal-activator[data-modal-id='gift-card-customization-modal']");
                    modalActivator.click();
                }
            }
        },

        onChangeSendInCopyCheckbox: function () {
            const checkbox = document.getElementById("is-send-in-copy-checkbox");
            const isActive = checkbox.checked;
            const emailInCopyWrapper = document.getElementById("email-in-copy-wrapper");

            if (isActive) {
                emailInCopyWrapper.classList.remove("hidden");
            } else {
                if (!emailInCopyWrapper.classList.contains("hidden")) {
                    emailInCopyWrapper.classList.add("hidden");
                }
            }
        },

        getAddToCartModal: async function () {
            const reference = document.getElementById("product-reference")?.value ?? "";
            const variantReference = document.getElementById("variant-reference")?.value ?? "";

            const params = new URLSearchParams({ reference, variantReference })

            try {
                const response = await fetch("/Product/GetAddToCartModal?" + params);

                const data = await response.json();

                const openModals = document.querySelectorAll(".maty-modal.-active");

                if (openModals.length > 0) {
                    openModals.forEach(modal => openModal.modal.close(false));
                }

                if (data.isValid) {
                    if (data.html) {
                        const modalEl = document.getElementById("add-to-cart-modal");
                        const modal = modalEl.modal;

                        const contentWrapper = modalEl.querySelector("#add-to-cart-content");

                        contentWrapper.innerHTML = data.html;

                        modal.open();

                        Foundation.libs.common.initSwipers(modalEl);
                    }

                    if (data.masterTag) {
                        Foundation.libs.common.refreshMasterTagData(data.masterTag);
                        Foundation.libs.common.refreshMasterTag();
                    }
                }
            } catch (e) {
                console.error(e);
            }
        },

        closeCartModal: function () {
            const modalEl = document.getElementById("add-to-cart-modal");
            const modal = modalEl.modal;
            modal.close();
        },

        removeProductFromWishlist: async function (reference) {
            const params = new URLSearchParams({ reference });

            try {
                Foundation.libs.common.showPreloader();

                const response = await fetch("/wishlist/RemoveInWishlistFromSelectionProduit?" + params, {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest"
                    }
                });

                if (response.redirected) {
                    window.location.replace(response.url);

                    return;
                }

                const data = await response.json();

                if (data.IsRedirect) {
                    window.location.replace(data.Redirect);

                    return;
                }

                if (data.IsValid) {
                    const button = document.querySelector(".wishlist-button");
                    button.classList.remove("-in-wishlist");
                    button.setAttribute("onclick", `Foundation.libs.product.addProductInWishlist("${reference}")`);

                    Foundation.libs.mastertag.trackWishlist({ action: "retrait des favoris" });

                    if (data.NumberInPicto) {
                        const wishlistHeaderPictogram = document.getElementById("wishlist-pictogram");
                        const productInWishlistIndicator = wishlistHeaderPictogram.querySelector(".product-nb");

                        if (productInWishlistIndicator) {
                            productInWishlistIndicator.remove();
                        }

                        // Ouai c'est moche... 
                        if (!data.NumberInPicto.includes(">0<")) {
                            wishlistHeaderPictogram.insertAdjacentHTML(
                                "beforeend",
                                data.NumberInPicto
                            );
                        }
                    }
                }
            } catch (e) {
                console.error(e);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        addProductInWishlist: async function (reference) {
            const url = window.location.pathname;
            const params = new URLSearchParams({ reference, url });

            try {
                Foundation.libs.common.showPreloader();

                const response = await fetch("/wishlist/AddInWishlist?" + params, {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest"
                    }
                });

                if (response.redirected) {
                    window.location.replace(response.url);

                    return;
                }

                const data = await response.json();

                if (data.IsRedirect) {
                    window.location.replace(data.Redirect);

                    return;
                }

                if (data.IsValid) {
                    const button = document.querySelector(".wishlist-button");
                    button.classList.add("-in-wishlist");
                    button.setAttribute("onclick", `Foundation.libs.product.removeProductFromWishlist("${reference}")`);

                    Foundation.libs.mastertag.trackWishlist({ action: "ajout aux favoris" });

                    if (data.NumberInPicto) {
                        const wishlistHeaderPictogram = document.getElementById("wishlist-pictogram");
                        const productInWishlistIndicator = wishlistHeaderPictogram.querySelector(".product-nb");

                        if (productInWishlistIndicator) {
                            productInWishlistIndicator.remove();
                        }

                        wishlistHeaderPictogram.insertAdjacentHTML(
                            "beforeend",
                            data.NumberInPicto
                        );
                    }
                }
            } catch (e) {
                console.error(e);
            } finally {
                Foundation.libs.common.hidePreloader();
            }
        },

        initAlmaWidget: function () {
            const almaWidget = document.getElementById("alma-widget");
            if (!almaWidget) return;

            if (!window.Alma) {
                const script = document.createElement('script');
                script.src = "https://cdn.jsdelivr.net/npm/@alma/widgets@3.x.x/dist/widgets.umd.js";
                script.onload = () => this.initAlma(); // appelé quand Alma est dispo

                const link = document.createElement("link");
                link.href = "https://cdn.jsdelivr.net/npm/@alma/widgets@3.x.x/dist/widgets.min.css";
                link.rel = "preload";
                link.as = "style";
                link.onload = () => link.rel = "stylesheet";

                document.head.appendChild(script);
                document.head.appendChild(link);
            } else {
                this.initAlma();
            }
        },

        initAlma: function () {
            const almaMerchantId = document.getElementById("alma-merchant-id")?.value;
            if (!almaMerchantId) return;

            var widgets = Alma.Widgets.initialize(
                almaMerchantId, // ID marchand
                Alma.ApiMode.LIVE, // mode de l'API (LIVE ou TEST)
            )

            const almaFacilitiesInputs = document.querySelectorAll("input.alma-facility");

            if (!almaFacilitiesInputs || almaFacilitiesInputs.length == 0) return;

            const plans = [];

            Array.from(almaFacilitiesInputs).forEach(facility => {
                plans.push({
                    installmentsCount: parseInt(facility.getAttribute("data-nb-mensuality")),
                    minAmount: parseFloat(facility.getAttribute("data-min-value")) * 100,
                    maxAmount: parseFloat(facility.getAttribute("data-max-value")) * 100,
                })
            });

            const productPrice = document.getElementById("product-price")?.value ?? null;

            if (!productPrice) return;

            const priceInCts = productPrice * 100;

            widgets.add(Alma.Widgets.PaymentPlans, {
                container: '#alma-widget',
                purchaseAmount: priceInCts,
                locale: window.Foundation.libs.matyWeglot.getLangCookie(),
                hideIfNotEligible: false,
                plans
            });

            const widget = document.getElementById("alma-widget");

            widget.addEventListener("click", () => {
                Foundation.libs.mastertag.trackClickAlma(widget);
                //Foundation.libs.mastertag.track_tc_event({
                //    trigger: "clic_alma", options: {

                //}})
            })
        },

        events: function () {
            var self = this;
            var S = this.S;
            //////////////////////////////////////////////////////////////
            //                          ETAPE1                          //
            //////////////////////////////////////////////////////////////
            $(this.scope)
                .ready(function (event) {
                    //tres important pour eviter le cache pour les requetes JSON
                    $.ajaxSetup({ cache: false });

                })
        },
        reflow: function () { },
    };
}(jQuery, window, window.document));

window.addEventListener("DOMContentLoaded", () => {
    Foundation.libs.product.initGlobal();
})
